import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { post } from '../api/api';
import { showToast } from '../components/utils/toast';
import { INote } from '../interface/notes';
import { AnalyticsFeatureOperation } from '../interface/analytics';
import { useAnalytics } from './useAnalytics';
type CreateNoteWithParams = {
  note?: string;
  significance?: string;
  transactionId?: string;
  activityId?: string;
  privatePersonId?: string;
  matterId?: string;
  preliminaryInvoiceId?: string;
  companyId?: string;
  expenseId?: string;
  matterRequestId?: string;
  params?: Record<string, string>;
};
const createNote = async (params: CreateNoteWithParams): Promise<INote> => {
  return post(API_URLS.NOTES_LIST, params);
};

export const useCreateNote = (): UseMutationResult<
  INote,
  AxiosError<{ message?: string; type?: string }>,
  CreateNoteWithParams
> => {
  const { setIsLoading } = useLoading();
  const { t } = useTranslation();
  const { trackBusinessEvent } = useAnalytics();

  return useMutation({
    mutationFn: createNote,
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: () => {
      trackBusinessEvent(AnalyticsFeatureOperation.NOTES_CREATED);
      showToast('success', t('note:noteCreateSuccess'));
    },
    onError: (error) => {
      showToast('error', error.message);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
